export enum MemberTab {
  OVERVIEW = 'overview',
  INVITATIONS = 'invitations',
}
